import { t, useLanguage } from "@/lib/i18n";
import React from "react";
import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fileUrl } from "@/lib/api";
import { cardPhotoCrop, cardPhotoStyle } from "@/lib/memberPhoto";

export default function CardPhotoEditor({ photo, name, onChange }) {
  useLanguage();
  if (!photo) return null;
  const crop = cardPhotoCrop(photo);
  const move = (axis, amount) => onChange({ ...crop, [axis]: Math.max(0, Math.min(100, crop[axis] + amount)) });
  return <div className="mt-4 rounded-xl border border-[#E6DEC3] bg-[#FAF7F2] p-4 space-y-3" data-testid="card-photo-editor">
    <p className="text-sm font-medium">{t("Adjust member card photo")}</p>
    <div className="flex flex-wrap items-center gap-5">
      <div className="w-[140px] h-[176px] rounded-2xl border-2 border-stone-200 bg-white p-3 flex flex-col items-center gap-2">
        <div className="w-20 h-20 shrink-0 rounded-lg overflow-hidden border-2 border-green-400">
          <img src={fileUrl(photo.path)} alt={t("Member card photo preview")} className="w-full h-full object-cover" style={cardPhotoStyle(photo)} />
        </div>
        <p className="text-sm font-semibold text-stone-700 text-center line-clamp-2 break-words mt-auto">{name || t("Member")}</p>
      </div>
      <div className="space-y-3">
        <div className="grid grid-cols-3 gap-1 w-fit">
          <span />
          <Button type="button" variant="outline" size="icon" aria-label={t("Move photo up")} disabled={crop.y >= 100} onClick={() => move("y", 5)}><ArrowUp size={18} /></Button>
          <span />
          <Button type="button" variant="outline" size="icon" aria-label={t("Move photo left")} disabled={crop.x >= 100} onClick={() => move("x", 5)}><ArrowLeft size={18} /></Button>
          <Button type="button" variant="outline" size="icon" aria-label={t("Move photo down")} disabled={crop.y <= 0} onClick={() => move("y", -5)}><ArrowDown size={18} /></Button>
          <Button type="button" variant="outline" size="icon" aria-label={t("Move photo right")} disabled={crop.x <= 0} onClick={() => move("x", -5)}><ArrowRight size={18} /></Button>
        </div>
        <label className="flex flex-col gap-1 text-sm">{t("Photo zoom (")}{Math.round(crop.zoom * 100)}%)
          <input type="range" min="1" max="3" step="0.1" value={crop.zoom} aria-label={t("Photo zoom")}
            onChange={(e) => onChange({ ...crop, zoom: Number(e.target.value) })} className="accent-amber-800" />
        </label>
        <Button type="button" variant="outline" size="sm" onClick={() => onChange({ x: 50, y: 50, zoom: 1 })}>{t("Reset photo position")}</Button>
      </div>
    </div>
    <p className="text-xs text-stone-600">{t("Use the arrows to move the photo. Zoom in for more room to adjust. Save the member to keep these changes.")}</p>
  </div>;
}
